import { AutoFields, AutoForm, SubmitField, authReducer, useForm } from '@bitstopco/bitstop-theme';
import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';

import { Button, DialogActions, DialogContent, Divider } from '@mui/material';
import toast from 'react-hot-toast';

import SCHEMAS from '@/forms/schemas';
import { useCreateCaseNoteMutation } from '@/store/api/services/operations/cases/index';

import { useAppSelector } from '@/store';
import type { CaseCustomNoteModel } from '@/types';

/**
 * Case Custom Note Modal
 *
 * @param {ModalChildrenProps} { hide, props }
 * @return {*}
 */
const CaseCustomNote = ({ hide, props }: ModalChildrenProps) => {
  const { schema } = useForm(SCHEMAS.CASE_CUSTOM_NOTE);
  const [createCaseCustomNote] = useCreateCaseNoteMutation();

  const {
    selectors: { userInfo },
  } = authReducer;

  const userData = useAppSelector(userInfo);

  const handleSubmit = async (data: CaseCustomNoteModel) => {
    try {
      await createCaseCustomNote({
        case_id: props.case_id,
        note_text: data.content,
        author: `${userData?.first_name} ${userData?.last_name}`,
      }).unwrap();
      toast.success('Note created successfully');
      hide();
    } catch {
      toast.error('Error creating note for this case');
    }
  };

  return (
    <AutoForm<CaseCustomNoteModel> showInlineError schema={schema} onSubmit={handleSubmit}>
      <DialogContent sx={{ my: 2 }}>
        <AutoFields />
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button onClick={hide}>Back</Button>
        <SubmitField variant="contained">Create Note</SubmitField>
      </DialogActions>
    </AutoForm>
  );
};

export default CaseCustomNote;
